// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"511":"2e1bb9b4","674":"ca782da4","705":"4d2393df"}[chunkId] + ".chunk.css";
};